import axios from 'axios'
axios.default.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/json'

const instance = axios.create()
instance.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use = instance.interceptors.request.use
instance.interceptors.request.use(config => {
  if (localStorage.getItem('token')) {
    config.headers.Authorization = `token ${localStorage.getItem('token')}`
      .replace(/(^")|("$)/g, '')
  }
  return config
}, err => {
  return Promise.reject(err)
});

// axios拦截响应
instance.interceptors.response.use(response => {
  return response
}, err => {
  return Promise.reject(err)
});

export default {
  checkdomain(data) {
    return instance.post('/api/checkdomain', data);
  },
  getinitdata(data) {
    return instance.post('/api/getinitdata', data);
  },
  // getappweb(data) {
  //   return instance.post('/api/getappweb', data);
  // },
  // getmatch(data) {
  //   return instance.post('/api/getmatch', data);
  // },
  homenews(data) {
    return instance.post('/api/homenews', data);
  },
  getlist(data) {
    return instance.post('/api/getlist', data);
  },
  getcontentByFunc(data) {
    return instance.post('/api/getcontentByFunc', data);
  },
  getcontent(data) {
    return instance.post('/api/getcontent', data);
  },
  // 查询报名信息
  getsigninfo(data) {
    return instance.post('/api/getsigninfo', data);
  },
  getimages(data) {
    return instance.post('/api/getimages', data);
  },
}



// WEBPACK FOOTER //
// ./src/axios.js